module.exports = __webpack_public_path__ + "static/media/accountExec-male-icon.fb9713b0.svg";